var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFaqIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9985 21.497V21.5556M14.4444 10.7289C14.4444 8.85358 16.0363 7.33333 18 7.33333C19.9637 7.33333 21.5556 8.85358 21.5556 10.7289C21.5556 12.6042 19.9637 14.1245 18 14.1245C18 14.1245 17.9985 15.138 17.9985 16.3882M22.3478 25.6522L18 34L14 25.6522H6C3.79086 25.6522 2 23.8613 2 21.6522V6C2 3.79086 3.79086 2 6 2H30C32.2091 2 34 3.79086 34 6V21.6522C34 23.8613 32.2091 25.6522 30 25.6522H22.3478Z",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqIcon);
export default __webpack_public_path__ + "static/media/faq-icon.4cfe17503635327eeb1ac00797d9a740.svg";
export { ForwardRef as ReactComponent };